export const CITATION_SEARCH = 'citation-search'
